var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.style }, [
    _c("div", { staticClass: "ad" }, [
      _c("img", { attrs: { src: _vm.activityBackgroundImage, alt: "" } }),
      _vm._v(" "),
      _c("img", {
        staticClass: "bgimg",
        attrs: {
          src: "//img1.jianyewy.com/ca8e5c5cb798586d19417c4e3108983d.png",
          alt: ""
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "titleDiv" }, [
      _c("p", { staticStyle: { "white-space": "pre-wrap" } }, [
        _vm._v(_vm._s(_vm.activityTitle ? _vm.activityTitle : "报名活动名称"))
      ]),
      _vm._v(" "),
      _c("div", [
        _c("ul", { staticClass: "content" }, [
          _c("li", [
            _c("div", { staticClass: "left" }, [
              _vm._v("\n            报名时间：\n          ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm._f("dateFormat")(
                      _vm.signStartTime !== ""
                        ? _vm.signStartTime
                        : new Date().valueOf(),
                      "yyyy-MM-dd hh:mm:ss"
                    )
                  ) +
                  " 至" +
                  _vm._s(
                    _vm._f("dateFormat")(
                      _vm.signEndTime !== ""
                        ? _vm.signEndTime
                        : new Date().valueOf(),
                      "yyyy-MM-dd hh:mm:ss"
                    )
                  ) +
                  "\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "left" }, [
              _vm._v("\n            限报人数：\n          ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._f("numberFilter")(_vm.activityLimitCount)) +
                  "人\n          "
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contentDiv" }, [
      _c("p", [_vm._v("活动内容")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("p", { staticClass: "title" }, [_vm._v("活动地点")]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "content",
              staticStyle: { "white-space": "pre-wrap" }
            },
            [_vm._v(_vm._s(_vm.activityAddress))]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("p", { staticClass: "title" }, [_vm._v("活动时间")]),
          _vm._v(" "),
          _c("p", { staticClass: "content" }, [
            _vm._v(
              "\n\n           " +
                _vm._s(
                  _vm._f("dateFormat")(
                    _vm.activityStartTime !== ""
                      ? _vm.activityStartTime
                      : new Date().valueOf(),
                    "yyyy-MM-dd hh:mm:ss"
                  )
                ) +
                " 至" +
                _vm._s(
                  _vm._f("dateFormat")(
                    _vm.activityEndTime !== ""
                      ? _vm.activityEndTime
                      : new Date().valueOf(),
                    "yyyy-MM-dd hh:mm:ss"
                  )
                ) +
                "\n\n\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("p", { staticClass: "title" }, [_vm._v("活动内容")]),
          _vm._v(" "),
          _c("p", {
            staticClass: "content",
            attrs: { id: "fuwenben" },
            domProps: { innerHTML: _vm._s(_vm.activityContent) }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn-sign" }, [_vm._v("我要报名")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }